import { ws } from "../../../utils/common";

export const getInfoUserWS = async () => {
  const res = await ws(
    "GET",
    process.env.REACT_APP_ENDPOINT + "user/?full=true",
    null,
    null,
    true
  );

  if (res.error) {
    throw res.data;
  } else {
    return res.data;
  }
};

export const getEventTypeWS = async () => {
  const res = await ws(
    "GET",
    process.env.REACT_APP_ENDPOINT + "event-type/",
    null,
    null,
    true
  );

  if (res.error) {
    throw res.data;
  } else {
    return res.data;
  }
};

export const updateUserWS = async ({ formData }) => {
  const res = await ws(
    "PUT",
    process.env.REACT_APP_ENDPOINT + "user/",
    null,
    formData,
    true
  );

  if (res.error) {
    throw res.data;
  } else {
    return res.data;
  }
};
